// import React, { useContext } from "react";
// import { userContext } from "./UserRoleContext";
// import useAuth from "../hooks/useAuth";
// // import axios from "axios";
// import { json } from "react-router-dom";
// import axios from "../api/axios";
// // import { data } from "autoprefixer";

// const useRefreshToken = () => {
//   const { authenticated, setAuthenticated } = useAuth();
//   console.log(authenticated, "auth value before");

//   const refresh = async () => {
//     axios.defaults.withCredentials = true;
//     const response = await axios.get("/auth/refreshtoken", {
//       withCredentials: true,
//     });
//     // console.log(response);

//     setAuthenticated((prev) =>  ({...prev,roles: [response?.data.role],accessToken: response?.data.accessToken}));
//     console.log(authenticated, "auth value after");

//     return response?.data.accessToken;
//   };
//   return refresh;
// };
// export default useRefreshToken;

import React, { useEffect } from "react";
import axios from "../api/axios";
import useAuth from "../hooks/useAuth";

const useRefreshToken = () => {
  const { authenticated, setAuthenticated } = useAuth();

  const refresh = async () => {
    try {
      axios.defaults.withCredentials = true; // Ensure cookies are sent
      const response = await axios.get("/auth/refreshtoken", {
        withCredentials: true,
      });

      // Update authenticated state
      setAuthenticated((prev) => ({
        ...prev,
        user: response?.data.user,
        roles: [response?.data.role],
        accessToken: response?.data.accessToken,
      }));

      // console.log("Access token refreshed:", response?.data.accessToken);
      return response?.data.accessToken; // Return new access token
    } catch (error) {
      console.error("Error refreshing token:", error);
      throw error; // Ensure the error is propagated
    }
  };

  // Log authenticated whenever it changes
  useEffect(() => {
    // console.log(authenticated, "Updated auth value");
  }, [authenticated]);

  return refresh;
};

export default useRefreshToken;
